






























































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import ResponsiveImage from 'frontend/components/ResponsiveImage.vue';
import { MobileGetter } from 'frontend/types';

@Component({
  components: {
    ResponsiveImage,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class CourseContents extends Vue {
  private isMobile!: MobileGetter;
  private useMobileStyles = false;

  private onResize() {
    this.useMobileStyles = document.body.clientWidth <= 960;
  }

  private mounted() {
    if (this.isMobile(this.$mq)) {
      this.useMobileStyles = true;
    } else {
      this.onResize();
      window.addEventListener('resize', this.onResize);
    }
  }

  private destroyed() {
    if (!this.isMobile(this.$mq)) {
      window.removeEventListener('resize', this.onResize);
    }
  }
}
